import Stack from '@mui/material/Stack';
import { Typography, colors } from '@sweep-io/sweep-design';
import { QuickSearchLightboxItem as QuickSearchLightboxItemType } from './types';
import { cloneElement, isValidElement } from 'react';

interface QuickSearchLightboxItemProps<T> {
  item: QuickSearchLightboxItemType<T>;
  onItemClick: (item: QuickSearchLightboxItemType<T>) => void;
  isHighlighted?: boolean;
}

export const QuickSearchLightboxItem = <T,>({
  item,
  onItemClick,
  isHighlighted,
}: QuickSearchLightboxItemProps<T>) => {
  const renderIcon = () => {
    if (!item.icon) return null;

    if (isValidElement(item.icon)) {
      return cloneElement(item.icon, {
        ...item.icon.props,
        size: 'medium',
        color: isHighlighted ? colors.blue[500] : colors.grey[700],
      } as any);
    }

    return item.icon;
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={2}
      sx={{
        cursor: 'pointer',
        borderRadius: '4px',
        minHeight: item.subtitle ? '70px' : '40px',
        width: '100%',
        '&:hover': {
          backgroundColor: colors.grey[100],
        },
      }}
      onClick={() => onItemClick(item)}
    >
      <Stack pl={1.5}>{renderIcon()}</Stack>
      <Stack>
        <Typography variant="body" color={isHighlighted ? colors.blue[500] : 'inherit'}>
          {item.title}
        </Typography>
        <Typography variant="body" color={colors.grey[700]}>
          {item.subtitle}
        </Typography>
      </Stack>
    </Stack>
  );
};
